import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const 	GET_REPLYS = "/api/getReplys", //获取自动回复内容
		SAVE_REPLYS = "/api/saveReplys" //保存回复内容
export default {
	getReplys:({
		commit
	}, params={}) => {
		return http.get(GET_REPLYS,params)
	},
	saveReplys:({
		commit
	}, params={}) => {
		return http.post(SAVE_REPLYS,params)
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/replys/actions.js